module.exports = __webpack_public_path__ + "img/1_orb.73ce428c.jpg";